module.exports = __webpack_public_path__ + "img/icon-service-inactive.c00adb50.png";